import React from "react";

const TimelineEntryBlock = ({ description }) => (
  <div>
    <p className="description">{description}</p>
  </div>
);

export default TimelineEntryBlock;
